// extracted by mini-css-extract-plugin
export var textInput = "_ji-0";